import { render } from "./invoicerecurring.vue?vue&type=template&id=a2ceab28"
import script from "./invoicerecurring.vue?vue&type=script&lang=js"
export * from "./invoicerecurring.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__